import {useQuery} from '@tanstack/react-query';
import axiosInstance from '../utils/api';
import paths from '../utils/paths';

export const useInspectionResultHistory = resultId => {
  return useQuery({
    queryKey: ['inspectionResultHistory', resultId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        paths.inspectionResultHistory(resultId),
      );
      return response.data?.data ?? response.data;
    },
    enabled: !!resultId,
  });
};
